import React from 'react';
import PropTypes from 'prop-types';
import { ReactComponent as IconCross } from '../resources/icon_cross.svg';

const PaymentsOSErrorLabel = ({ content }) => {
    return (
        <>
            {content && (
                <div className="wz-lyriapay-payline-errorlabel">
                    <div className="wz-lyriapay-payline-errorlabel-icon">
                        <IconCross />
                    </div>
                    <div className="wz-lyriapay-payline-errorlabel-content">
                        {content}
                    </div>
                </div>
            )}
        </>
    );
};

PaymentsOSErrorLabel.propTypes = {
    content: PropTypes.node
};

export default PaymentsOSErrorLabel;